import FactoryComponents from '../../../../../../factory/components/FactoryComponents.js';
import moment from "moment/moment";
import ProcessWorkPermitSelectPopup from '../../workPermit/ProcessWorkPermitSelectPopup.vue';

const root = {}
export default root
root.name = 'processWorkPermitCD';
root.props = {
	initUserData: Object,
	areaData: Object,
	operaDataCache: Object,
	workerSelect: Array,
	applicantSelect: Array,
	departmentSelect: Array
}
root.components = {
	ProcessWorkPermitSelectPopup
}
root.data = {
	workPermitCDData: {
		isShowProcessWorkPermitSelectPopup: false,
		preWorkInfo: [],
		headerDataCache: {
			//作业证编号
			no: '',
			//作业证名称
			name: new Date().getTime(),
			//计划开始时间
			planStartTime: null,
			//计划结束时间
			planEndTime: null,
			//区域id
			locationId: null,

			departmentId:0,
			//作业地点
			place: '',
			protectionProduct: '',
			acceptanceEmpId: Number(localStorage.getItem("empId")), // 完工验收人id
			acceptanceOpinion: '',	//完收验工意见
			reviewEmpId: Number(localStorage.getItem("empId")), // 复核人id
			reviewOpinion: '',	//复核人意见
			jobExecutorEmpId: 0,//TODO 作业人id
			applyUserId: Number(localStorage.getItem("empId")), // 申请人id
			applyTime: moment().format('YYYY-MM-DD HH:mm:ss'),//申请作业时间
			contractorId: null, // 申请单位id
			certificateTypeId: 8,
		},

		//操作的缓存数据
		operaDataCache: {
			//其他特殊作业
			oso: '',
			//涉及的其他特殊作业安全作业证编号
			oson: '',
			//盲板位置图及编号
			ldan: '',
			//危险辨识
			hi: '',
			//安全措施
			sms: [],
			//设备管道名称
			epn: '',
			//介质
			medium: '',
			//温度
			temp: '',
			//压力
			pressure: '',
			//材质
			bm: '',
			//规格
			bs: '',
			//编号
			bn: '',
			//作业人堵
			od: '',
			//作业人抽
			oc: '',
			//堵监护人
			gd: '',
			//抽监护人
			gc: '',
			//相关说明
			description: '',
			//签字人id
			signId: Number(localStorage.getItem("empId")),
			//签字时间
			signTime: moment().format('YYYY-MM-DD HH:mm:ss'),
			//安全交底人
			aqjdrId: 0,
			//接受交底人
			jsjdrId: 0,
			branchCharger: 0,//生产车间(分厂)负责人负责人
			branchChargerComment: '',//生产车间(分厂)负责人意见
			companyCharger: 0,//作业单位负责人
			companyChargerComment: '',//作业单位负责人意见
			approveCharger: 0,//审批负责人
			approveChargerComment: '',//审批负责人意见
		},
	},
	// 上传附件
	fileList: [],
}

root.methods = {
	//格式化选择的涉及的其他特殊作业及编号
	formatPreWorkInfo: function () {
		let data = []
		for (var i = 0; i < this.workPermitCDData.preWorkInfo.length; i++) {
			let element = this.workPermitCDData.preWorkInfo[i]
			data.push(`${element.name}(${element.no})`)
		}

		data = data.join(',')
		return data
	},
	//获取选择的涉及的其他特殊作业及编号
	getWorkPermitData: function (e) {
		this.workPermitCDData.preWorkInfo = []
		e.forEach(element => {
			element.selectData.forEach(item => {
				this.workPermitCDData.preWorkInfo.push({ 'no': item.no, 'name': item.name })
			});
		});
		this.$store.commit('setPreWorkInfo', this.workPermitCDData.preWorkInfo)
		this.workPermitCDData.isShowProcessWorkPermitSelectPopup = false

	},
	toOpenWorkCodePopup: function () {
		this.workPermitCDData.isShowProcessWorkPermitSelectPopup = true
	},
	returnCacheData: function () {
		return { ...this.workPermitCDData.headerDataCache, blindBoardPropsDto: this.workPermitCDData.operaDataCache };
	},

	// 解析业务字段，编辑时按新增页默认字段补齐
	fillPermitData: function (data, preserveWhenMissing) {
		data = data || {};
		this.workPermitCDData.headerDataCache = { ...this.workPermitCDData.headerDataCache, ...data };
		let businessData = {};
		if (data.businessJson) {
			if (typeof data.businessJson === 'object') {
				businessData = data.businessJson;
			} else {
				try {
					businessData = JSON.parse(data.businessJson);
				} catch (e) {
					businessData = {};
				}
			}
		}
		this.workPermitCDData.operaDataCache = { ...this.workPermitCDData.operaDataCache, ...businessData };
		if (!Array.isArray(this.workPermitCDData.operaDataCache.sms) || !this.workPermitCDData.operaDataCache.sms.length) {
			this.workPermitCDData.operaDataCache.sms = [];
			this.getPermitTypeData();
		}
		this.backfillPreWorkInfo(data, preserveWhenMissing);
	},
	// 回填涉及的其他特殊作业及编号
	backfillPreWorkInfo: function (data, preserveWhenMissing) {
		const hasPreWorkInfo = data && Object.prototype.hasOwnProperty.call(data, 'preWorkInfo');
		if (!hasPreWorkInfo && preserveWhenMissing) {
			this.$store.commit('setPreWorkInfo', this.workPermitCDData.preWorkInfo);
			return;
		}
		let preWorkInfo = hasPreWorkInfo ? data.preWorkInfo : [];
		if (typeof preWorkInfo === 'string') {
			try {
				preWorkInfo = preWorkInfo ? JSON.parse(preWorkInfo) : [];
			} catch (e) {
				preWorkInfo = [];
			}
		}
		if (!Array.isArray(preWorkInfo)) {
			preWorkInfo = [];
		}
		this.workPermitCDData.preWorkInfo = preWorkInfo;
		this.$store.commit('setPreWorkInfo', preWorkInfo);
	},

	//数据回填
	dataBackfill: function (data) {
		this.fillPermitData(data, true);
	},

	// 选择作业人
	jobExecutorChange: function (id) {
		this.workPermitCDData.headerDataCache.jobExecutorEmpId = id;
	},

	//获取作业证中的sms
	getPermitTypeData: function () {
		const self = this;
		self.componentsMoudel.startPost('/safetyMeasures/list_all', { permitType: 5 }, true).then(res => {
			self.workPermitCDData.operaDataCache.sms = res.body.data;
		});
	},
	// 上传的事件
	handleChange(file, fileList) {
		this.fileList = fileList
	},
	handleExceed(file, fileList) {
		this.$message.warning('限制上传一个文件')
	},
}

root.mounted = function () {
	if (this.operaDataCache.businessJson) {
		this.fillPermitData(this.operaDataCache);
	} else {
		this.workPermitCDData.operaDataCache.sms = [];
		this.backfillPreWorkInfo(this.operaDataCache);
		this.getPermitTypeData();
	}
}
FactoryComponents.initComponent(root);
